<template>
	<div v-if="params.isCheckbox">
		<el-checkbox-group v-model="myCheckValue">
			<el-checkbox :label="option._id" v-for="option in totaloptions" :key="option._id">{{option.name}}</el-checkbox>
		</el-checkbox-group>
	</div>
	<div v-else>
		<div class="relate-item-group">
			<div class="mr-2 relate-item" v-for="(item,index) in myValue" :key="item._id">
				{{item.name}}
				<span class="float-right text-muted">
					<span @click="handlerReOrder(index,-1)" class="op-btn el-icon-arrow-up" v-if="index>0"></span>
					<span
						@click="handlerReOrder(index,1)"
						class="op-btn el-icon-arrow-down"
						v-if="index<myValue.length-1"
					></span>
					<span @click="handleClose(index)" class="op-btn el-icon-close"></span>
				</span>
			</div>
		</div>
		<hr>
		<label>添加</label>
		<el-select
			v-model="tmpNew"
			value-key="_id"
			filterable
			remote
			:clearable="true"
			placeholder="请搜索"
			@change="handleChange"
			:remote-method="refreshData"
			:loading="loading"
		>
			<el-option v-for="item in options" :key="item._id" :label="calcName(item)" :value="item"></el-option>
		</el-select>
	</div>
</template>
<script>
import RelateInput from "@/mixins/RelateInput.js";

export default {
	mixins: [RelateInput],

	data() {
		return {
			id: "",
			loading: false,
			isMulti: true,
			tmpNew: {
				name: "",
				_id: ""
			},
			myCheckValue: []
		};
	},
	props: {
		dataModelName: {
			type: String,
			default: ""
		},
		nameFields: {
			type: Array,
			default: () => {
				return ["name"];
			}
		},
		value: {
			type: Array,
			default: () => {
				return [];
			}
		},
		params: {
			type: Object,
			default: function() {
				return {
					allowCreate: true,
					isCheckbox: false
				};
			}
		}
	},
	created() {},
	mounted() {},
	watch: {
		dataModelName: {
			handler(val) {
				this.dataModel = this.dataModelName;
			},
			immediate: true
		}
	},
	methods: {
		handleClose(index) {
			this.myValue.splice(index, 1);
		},
		handlerReOrder(index, direction) {
			if (direction == -1 && index == 0) {
				return;
			}
			if (direction == 1 && index == this.myValue.length - 1) {
				return;
			}
			let tempOption = this.myValue[index + direction];
			this.$set(this.myValue, index + direction, this.myValue[index]);
			this.$set(this.myValue, index, tempOption);
		},
		resetEditor(val) {
			this.myValue = [];
			if (!val) {
				return;
			}
			for (let i = 0; i < val.length; i++) {
				this.myValue.push(val[i]);
			}
		},
		calcName(item) {
			let names = [];
			for (let k in this.nameFields) {
				names.push(item[this.nameFields[k]]);
			}
			return names.join(" / ");
		},
		handleChange(newVal) {
			let index = this.myValue.findIndex(val => {
				return val._id == newVal._id;
			});
			if (index == -1) {
				this.myValue.push(newVal);
				this.$emit("input", this.myValue);
				this.$emit("change", this.myValue);
			}
		}
	},
	components: {}
};
</script>
